import { consolidatedPositionStrategyEnum } from './constants';

export const isAssetStrategy = (strategy: string) => {
  return Object.keys(consolidatedPositionStrategyEnum).includes(strategy);
};
